import Decimal from 'decimal.js';

export class SelectedPriceDto {
    fee: string;

    today: string;

    non_discounted: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawSelectedPrice: any) {
        this.fee = new Decimal(rawSelectedPrice.fee).toFixed(2);
        this.today = new Decimal(rawSelectedPrice.today).toFixed(2);
        this.non_discounted = new Decimal(rawSelectedPrice.non_discounted).toFixed(2);
    }
}
